import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 10px 20px;
  box-sizing: border-box;
  width: 500px;
  background: ${({ theme }) => theme.palette[10]};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 20px;
`

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 10px;
  gap: 14px;
  width: 100%;
  box-sizing: border-box;
`

export const Icon = styled.img`
  &:hover {
    cursor: pointer;
  }
`

export const DynamicRowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const DynamicRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const RemoveButton = styled.img`
  cursor: pointer;
  width: 16px;
  height: 16px;
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`

type HideProps = {
  active: boolean;
}

export const HideContainer = styled.div<HideProps>`
  max-height: ${({ active }) => active ? '1000px' : '0px'};
  overflow: ${({ active }) => active ? '' : 'hidden'};
  transition: max-height 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const SectionLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette[700]};
  margin-top: 4px;
`
